import AppService from './appService'
import type { ContextStore } from '@/stores/context'
export default class ShopService extends AppService {
  constructor(appContext: ContextStore) {
    super(appContext)
  }

  async sync() {
    try {
      return await this.mboApiV1.get(`shops/sync`, {
        params: {
          mboVersion: this.context.mboVersion,
        },
      })
    } catch (err) {
      console.error(err)
    }
  }
}
